import React, { useEffect, useState, useCallback } from "react";
// import { Link } from "react-router-dom";
import { ApiService } from "../../../services/ApiService";
// import {useAlert} from 'react-alert'
import { SystemConfigNavbar } from "./reusedcomponent/Navbar";
import { PageBody } from "../../../components/loader";
import { useLoadingMessage } from "../../../components/useLoadingMessage";
import { systemConfigThunk } from "../../../store/actions/systemconfiguration/systemconfig.thunk";
import { useDispatch, useSelector } from "react-redux";

export const SystemConfig = () => {
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const [loader, setLoader] = useState(false);
  const { roles } = useSelector((state) => state.systemConfig);
  const dispatch = useDispatch();

  const getRoles = useCallback(async () => {
    updateLoader(true, "Loading");
    setLoader(true);
    await dispatch(systemConfigThunk.getRoles());
    setLoader(false);
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getRoles();
  }, []);

  return (
    <PageBody isLoading={isLoading} message={message}>
      <React.Fragment>
        <SystemConfigNavbar />
        <div class="row container">
          <div class="col-sm-12 col-md-12 col-xs-12">
            <div class="table-wrapper table-responsive">
              <div class="table-title">
                <div class="row">
                  <div class="col-sm-6">
                    <h2>
                      <b>ROLES </b>{" "}
                    </h2>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-12">
                  <div class="registration-form">
                    <table
                      id="dtMaterialDesignExample"
                      class="table table-striped table-hover role-config-table dtMaterialDesignExample"
                      cellspacing="0"
                      width="100%"
                    >
                      <thead>
                        <tr>
                          <th class="th-sm">
                            <b>ROLES</b>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {roles.map((role, i) => (
                          <tr key={i}>
                            <td>{role.name.toUpperCase()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    </PageBody>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/systemconfiguration/index.js